import { UpdateContact } from "../../app/data/terminal-details/models";

export interface UpdateContactState {
    data: UpdateContact | null;  
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage?: string | null;
}

export const initialUpdateContactState: UpdateContactState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
};
  